<template>
  <div class="set-language">
      <label v-if="title">{{title | setText('Выберите язык интерфейса')}}</label>
      <select class="form-control" name="lang"  @change="setLanguage">
          <option :value="code" :selected="code==$store.state.language_current" v-for="(language,code) in $store.state.languages">{{language}}</option>
      </select>
  </div>
</template>
<script>
export default {

  props:{
    title: {
      default:''
    }
  },
  methods: {
    setLanguage(event){
        this.$loading(true);

        let  lang = event.target.value;
        this.$store.dispatch('setLanguageCurrent',event.target.value);
        localStorage.setItem("lang", lang);
        window.location.reload();
    }
  },
};
</script>

<style lang="scss">
  .set-language {

    width:100%;
  
    margin-top:10px;
    margin-bottom:30px;
    & label {
   
    }
    & select {
          border-radius: 8px;
          border:1px solid black;
          margin:auto;
    } 
  }
</style>

